<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="unitLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="unitCluster"
            id="unit-layer"
        ></l-feature-group>
    </l-layer-group>
</template>
<script>
import {LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters, mapActions} from "vuex";
import {useToast} from "vue-toastification";
import debounce from "lodash/debounce";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";

export default {
    setup() {
        return {
            debounceUpdate: debounce((fn) => fn(), 400),
        }
    },
    name: "SectionMap_layer_unit_edit",
    emits: ['update:modelValue'],
    mixins: [unitLmsgMixin],
    inject: ['L', 'unitIconByType'],
    props: {
        modelValue: Object,
    },
    components: {
        LFeatureGroup,
        LLayerGroup,
    },
    data() {
        return {
            toast: useToast(),
            unitLayer: null,
            unitCluster: null,
            dragMarker: false,
        }
    },
    computed: {
        ...mapGetters([
            "getUnitsMarkersOptionsByIds",
            "isUnitsLiteLoad",
        ]),
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        unitId() {
            return this.isShowLayer ? this.routeFilter.unitId : null
        },
        unitMarkerOptions() {
            return this.getUnitsMarkersOptionsByIds[this.unitId]
        },
        updateUnitMarker() {
            if(!this.isShowLayer || this.dragMarker) return null
            return [this.unitId, this.unitLmsgLatLng?.lat, this.unitLmsgLatLng?.lng].join(',')
        },
    },
    watch: {
        updateUnitMarker: {
            handler: function (newVl) {
                if(newVl) {
                    this.debounceUpdate(() => this.updateMarker())
                }
            },
        }
    },
    methods: {
        ...mapActions([
        ]),
        modalClose() {
            this.modalWindows = {}
        },
        _unitIcon(){
            return false;
        },
        onReady() {
            if(this.$isDevelopment) console.log('ready')
            this.unitLayer = this.$refs.unitLayer.leafletObject
            this.unitCluster = this.$refs.unitCluster.leafletObject
        },
        updateMarker() {
            this.unitCluster.clearLayers()
            if(!this.unitId) return false;
            let icon = //this._unitIcon(this.unitMarkerOptions) ||
                    this.unitIconByType(this.unitMarkerOptions)
            let options = {
                ...this.unitMarkerOptions,
                latlng: this.unitLmsgLatLng,
                draggable: true,
                icon,
            }
            if (!options || !options.latlng) return false
            let marker = this.L.marker(options.latlng, options);
            if(this.unitLmsg?.no_coords) {
                marker
                    .off("drag")
                    .on("drag", (e) => {
                        let marker = e.target;
                        this.dragMarker = true
                        this.debounceUpdate(() => this.updateUnitLocation(marker))
                    })
                    .off('mouseup')
                    .on('mouseup', () => {
                        this.dragMarker = false
                    });
            }

            this.unitCluster.addLayer(marker);
        },
        updateUnitLocation(marker) {
            this.unit.coords = marker.getLatLng()
        },
    },
    created() {
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
    }
}
</script>

<style scoped>

</style>